import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";
import ImgUser from "../assets/images/menu/user.png";
import ImgAgency from "../assets/images/menu/agency.png";
import ImgOperator from "../assets/images/menu/operator.png";
import ImgRedeemUsage from "../assets/images/menu/redeem_usage.png";
import ImgRedeem from "../assets/images/menu/redeem.svg";
import { useRole } from "components/Hooks/UserHooks";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";

const Navdata = () => {
  const history = useNavigate();
  const { t } = useTranslation();
  const { userPermissions } = useRole();

  const [menuActive, setMenuActive] = useState<string>("DASHBOARD");

  // Multi Level
  const [isMultiLevel, setIsMultiLevel] = useState<boolean>(false);
  const [isLevel1, setIsLevel1] = useState<boolean>(false);
  const [isLevel2, setIsLevel2] = useState<boolean>(false);

  const [isCurrentState, setIsCurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history]);

  const menuItems: any = [
    {
      id: "agency_management",
      label: t("Agency Management"),
      link: ROUTES.AGENCY_LIST_MANAGEMENT,
      isChildItem: false,
      stateVariables: menuActive === "Agency",
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgAgency}
          alt="Agency"
          width={22}
          height={22}
        />
      ),
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.AGENCY_LIST],
        userPermissions
      ),
      click: function (e: any) {
        // e.preventDefault();
        setMenuActive((prev) => "Agency");
        setIsCurrentState((prev) => "Agency");
        updateIconSidebar(e);
      },
    },
    // {
    //   id: "prepayment_management",
    //   label: t("Agency Prepayment"),
    //   link: ROUTES.AGENCY_PREPAYMENT,
    //   isChildItem: false,
    //   stateVariables: menuActive === "Prepayment",
    //   icon: (
    //     <img
    //       className="menu-custom__icon"
    //       src={ImgPrepayment}
    //       alt="Agency Prepayment"
    //       width={22}
    //       height={22}
    //     />
    //   ),
    //   isShow: isHavePermissionRole(
    //     [ROLES_FOR_APP.PREPAYMENT_LIST],
    //     userPermissions
    //   ),
    //   click: function (e: any) {
    //     // e.preventDefault();
    //     setMenuActive((prev) => "Prepayment");
    //     setIsCurrentState((prev) => "Prepayment");
    //     updateIconSidebar(e);
    //   },
    // },
    {
      id: "user_star_management",
      label: t("User Management"),
      link: ROUTES.USER_STAR,
      isChildItem: false,
      stateVariables: menuActive === "User Star",
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgUser}
          alt="User Management"
          width={22}
          height={22}
        />
      ),
      isShow: isHavePermissionRole([ROLES_FOR_APP.USER_LIST], userPermissions),
      click: function (e: any) {
        // e.preventDefault();
        setMenuActive((prev) => "User Star");
        setIsCurrentState((prev) => "User Star");
        updateIconSidebar(e);
      },
    },
    {
      id: "operator_management",
      label: t("Operator Management"),
      link: ROUTES.OPERATOR_LIST,
      isChildItem: false,
      stateVariables: menuActive === "Operator",
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgOperator}
          alt="Operator Management"
          width={26}
          height={26}
        />
      ),
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.OPERATOR_LIST],
        userPermissions
      ),
      click: function (e: any) {
        // e.preventDefault();
        setMenuActive((prev) => "Operator");
        setIsCurrentState((prev) => "Operator");
        updateIconSidebar(e);
      },
    },
    // {
    //   id: "redeem_code_management",
    //   label: t("Redeem Management"),
    //   icon: (
    //     <img
    //       className="menu-custom__icon"
    //       src={ImgAgency}
    //       alt="Redeem"
    //       width={22}
    //       height={22}
    //     />
    //   ),
    //   link: ROUTES.REDEEM_CODE_MANAGEMENT,
    //   click: function (e: any) {
    //     e.preventDefault();
    //     setMenuActive((prev) => "Redeem Code");
    //     setIsCurrentState((prev) => "Redeem Code");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: menuActive === "Redeem Code",
    //   // isShow: isHavePermissionRole(
    //   //   [ROLES_FOR_APP.REDEEM_CODE_LIST],
    //   //   userPermissions
    //   // ),
    //   isShow: true,
    //   subItems: [
    //     {
    //       id: "issue",
    //       label: t("Redeem Code Issue"),
    //       link: ROUTES.REDEEM_CODE_ISSUE,
    //       isShow: true,
    //       // isShow: isHavePermissionRole(
    //       //   ROLES_FOR_APP.REDEEM_CODE_LIST,
    //       //   userPermissions
    //       // ),
    //     },
    //     {
    //       id: "usage",
    //       label: t("Redeem Code Usage"),
    //       link: ROUTES.REDEEM_CODE_USAGE,
    //       isShow: true,
    //       // isShow: isHavePermissionRole(
    //       //   ROLES_FOR_APP.REDEEM_CODE_LIST,
    //       //   userPermissions
    //       // ),
    //     },
    //   ],
    // },
    {
      id: "issue",
      label: t("Redeem Code Issue"),
      link: ROUTES.REDEEM_CODE_ISSUE,
      isChildItem: false,
      stateVariables: menuActive === "Redeem Code Issue",
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgRedeem}
          alt="Redeem Code Issue"
          width={22}
          height={22}
        />
      ),
      isShow: true,
      click: function (e: any) {
        // e.preventDefault();
        setMenuActive((prev) => "Redeem Code Issue");
        setIsCurrentState((prev) => "Redeem Code Issue");
        updateIconSidebar(e);
      },
    },

    {
      id: "usage",
      label: t("Redeem Code Usage"),
      link: ROUTES.REDEEM_CODE_USAGE,
      isChildItem: false,
      stateVariables: menuActive === "Redeem Code Usage",
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgRedeemUsage}
          alt="Redeem Code Usage"
          width={22}
          height={22}
        />
      ),
      isShow: true,
      click: function (e: any) {
        // e.preventDefault();
        setMenuActive((prev) => "Redeem Code Usage");
        setIsCurrentState((prev) => "Redeem Code Usage");
        updateIconSidebar(e);
      },
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
